<template lang="pug">
v-dialog(v-model="show", persistent, max-width="50%")
    v-card(v-if="indicadores")
        v-card-title(v-if="showBruto").title Total Bruto
        v-card-title(v-if="!showBruto").title Total Líquido
        v-card-text
          
          v-layout(column,wrap, style="background-color:#FAFAFA; border-radius:8px").pt-3.pb-3.mb-3.mt-3.pl-3.pr-3
            v-layout(row,wrap).pb-1
              v-flex.md12.xs12
                label(style="font-weight:400;font-size:18px; color:#111312CC") Total pago com pagamento online
            v-layout(row,wrap)
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") {{ indicadores.quantidade_pgt_online | number }} pedidos
              v-flex.md4.xs12.text-md-right(style="font-size:16px; color:#0F7641")
                strong(v-if="showBruto") +{{ indicadores.total_pgt_online_sem_taxa_servico | currency }}
                strong(v-if="!showBruto") +{{ indicadores.total_liquido_pgt_online_sem_taxa_servico | currency }}
            v-layout(row,wrap, v-if="indicadores.quantidade_taxa_servico_pgt_online > 0")
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") {{ indicadores.quantidade_taxa_servico_pgt_online | number }} taxas de serviço
              v-flex.md4.xs12.text-md-right(style="font-size:16px; color:#0F7641")
                strong +{{ indicadores.total_taxa_servico_pgt_online | currency }}
          
          v-layout(column,wrap, style="background-color:#FAFAFA; border-radius:8px").pt-3.pb-3.mb-3.mt-3.pl-3.pr-3
            v-layout(row,wrap).pb-1
              v-flex.md12.xs12
                label(style="font-weight:400;font-size:18px; color:#111312CC") Total pago em dinheiro
            v-layout(row,wrap)
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") {{ indicadores.quantidade_pgt_dinheiro | number }} pedidos
              v-flex.md4.xs12.text-md-right(style="font-size:16px; color:#0F7641")
                strong(v-if="showBruto") +{{ indicadores.total_pgt_dinheiro_sem_taxa_servico | currency }}
                strong(v-if="!showBruto") +{{ indicadores.total_liquido_pgt_dinheiro_sem_taxa_servico | currency }}
            v-layout(row,wrap, v-if="indicadores.quantidade_taxa_servico_pgt_dinheiro > 0")
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") {{ indicadores.quantidade_taxa_servico_pgt_dinheiro | number }} taxas de serviço
              v-flex.md4.xs12.text-md-right(style="font-size:16px; color:#0F7641")
                strong +{{ indicadores.total_taxa_servico_pgt_dinheiro | currency }}
          
          v-layout(column,wrap, style="background-color:#FAFAFA; border-radius:8px").pt-3.pb-3.mb-3.mt-3.pl-3.pr-3
            v-layout(row,wrap).pb-1
              v-flex.md12.xs12
                label(style="font-weight:400;font-size:18px; color:#111312CC") Total pago com maquininha de cartão
            v-layout(row,wrap)
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") {{ indicadores.quantidade_pgt_maquininha | number }} pedidos
              v-flex.md4.xs12.text-md-right(style="font-size:16px; color:#0F7641")
                strong(v-if="showBruto") +{{ indicadores.total_pgt_maquininha_sem_taxa_servico | currency }}
                strong(v-if="!showBruto") +{{ indicadores.total_liquido_pgt_maquininha_sem_taxa_servico | currency }}
            v-layout(row,wrap, v-if="indicadores.quantidade_taxa_servico_pgt_maquininha > 0")
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") {{ indicadores.quantidade_taxa_servico_pgt_maquininha | number }} taxas de serviço
              v-flex.md4.xs12.text-md-right(style="font-size:16px; color:#0F7641")
                strong +{{ indicadores.total_taxa_servico_pgt_maquininha | currency }}

          
          div(style="border:1px solid; border-radius:8px; color:#0000000A").pt-3.pb-3.mb-3.mt-3.pl-3
            v-layout(row,wrap, v-if="indicadores.quantidade_taxa_servico").pb-1
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") Total de {{ indicadores.quantidade_pedidos | number }} pedidos
              v-flex.md4.xs12.text-md-right.pr-3(style="font-size:16px; color:#0F7641",v-if="showBruto")
                strong +{{ indicadores.total_bruto_sem_taxa_servico | currency }}
              v-flex.md4.xs12.text-md-right.pr-3(style="font-size:16px; color:#0F7641",v-if="!showBruto")
                strong +{{ indicadores.total_liquido_sem_taxa_servico | currency }}
            v-layout(row,wrap, v-if="indicadores.quantidade_taxa_servico").pb-2
              v-flex.md8.xs12
                small(style="font-size:16px; color:#1113128A") Total de {{ indicadores.quantidade_taxa_servico | number }} taxas de serviço
              v-flex.md4.xs12.text-md-right.pr-3(style="font-size:16px; color:#0F7641")
                strong +{{ indicadores.total_taxa_servico | currency }}

            v-layout(row,wrap,v-if="showBruto")
              v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                strong Total Bruto
              v-flex.md4.xs12.text-md-right.pr-3(style="font-size:18px; color:#000")
                strong {{ indicadores.total_bruto | currency }}
            v-layout(row,wrap,v-if="!showBruto")
              v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                strong Total Líquido
              v-flex.md4.xs12.text-md-right.pr-3(style="font-size:18px; color:#000")
                strong {{ indicadores.total_liquido | currency }}
        
        v-card-actions.mr-4.pb-3
            v-spacer
            v-btn(flat,@click="close()") Fechar

</template>
  
<script>

export default {
  props: {
  },
  data () {
    return {
        show : false,
        indicadores : null,
        showBruto: true
    }
  },
  created () {
    
  },
  watch: {
  },
  computed: {
  },
  methods: {
    open(indicadores, bruto){
      const vm = this;
      vm.indicadores = indicadores;
      console.log(indicadores);
      vm.show = true;
      vm.showBruto = bruto
    },
    close(){
        const vm = this;
        vm.indicadores = null;
        vm.show = false;
    }
  }
}
</script>